module.exports = __webpack_public_path__ + "media/victory+cool.fb9c4313.mp3";